var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wizard-drag-zone",style:(_vm.computedStyle)},[_c('eg-icon',{staticClass:"drag-handle",attrs:{"icon":"list-dots-dual-column","size":_vm.iconSize,"color":_vm.iconColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }